module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAI9JREFUOBHdUtsNgDAIbN1/nTqMDoPwYQKEgk0rJvLFo1yPg1IyDACOV/5BYFgFvK0C0jhdYCTfaALHmgbjceUBgVQ0ypHPa5Z/v7VqXcbW45Hcv4D3YHR3eaL3ycJEgxPka4zsozumAbkJaabuWCvB7zpfCs1mNP6EcXTHegixPFGkFYvERJAmxTlBMqf1AmYNehudOz70AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignLeft_normal.png
// module id = 307
// module chunks = 0